import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
    projectsGridContainer:{
        margin: '0px auto',
    },
    projectGridContainer:{
        width:'500px',
        margin: '0px 100px'
    },
    media: {
        height: '150px',
        width: '250px',
        // paddingTop: '56.25%',
        backgroundColor: 'rgba(0, 0, 0, 0.2)',
        backgroundBlendMode: 'darken',
      },
    card: {
        display: 'flex',
        // flexDirection: 'row',
        justifyContent: 'flex-start',
        borderRadius: '15px',
        height: '150px',
        position: 'relative',
        textAlign:'left'
      },
      chip:{
        fontSize: "16px",
        margin: "5px",
        color: "#ADADAD",
        //backgroundColor: "rgb(217, 220, 223,0.4)",
        background: 'rgba(217, 220, 223, 0.4)',
        border: "1px solid #FFFFFF",
        //box-sizing: border-box;
        borderRadius: "25px",
        height: '36px',
      }
}));